import storage from 'redux-persist/lib/storage';

/**
 * دامنه انتخاب‌شده را مستقیماً از storage مربوط به redux-persist پاک می‌کند.
 * برای مسیرهایی مثل logout/401 که ممکن است قبل از flush شدن persist ریدایرکت شوند.
 */
export async function clearPersistedSelectedDomain(): Promise<void> {
  try {
    const raw = await storage.getItem('persist:root');
    if (!raw) return;

    const root = JSON.parse(raw) as Record<string, string>;
    // در redux-persist مقدار هر کلید whitelist به صورت JSON string ذخیره می‌شود
    root.selectedDomain = JSON.stringify({});
    await storage.setItem('persist:root', JSON.stringify(root));
  } catch {
    // در صورت خطا در خواندن/نوشتن storage، مانع logout نشویم
  }
}
